import { i18n } from 'next-i18next'
import { currencySymbolMap } from './currencies/code-symbol.array'


export const getSymbolFromCurrency = (currencyCode: string) => {
  if(typeof currencyCode !== 'string') return undefined
  const code = currencyCode.toUpperCase()
  if (!Object.prototype.hasOwnProperty.call(currencySymbolMap, code)) {
    return undefined
  }
  return currencySymbolMap[code]
}

export const getFormatedPrice = (price: number, currency = 'EUR') => {
  if (currency === 'CLP') {
    return new Intl.NumberFormat(i18n.language, {
      currency: 'CLP',
      style: 'currency',
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })?.format(Math.round(price))
  }
  return new Intl.NumberFormat(
    i18n.language,
    { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }
  )?.format(price)
}
